module.exports = __webpack_public_path__ + "images/assets/b5a561bd70420c1ff25af186e082d1d2.svg";